import withLazyImport from '../../../common/hoc/with-lazy-import';

export const RICH_CONTENT_EDITOR_ONE_APP_COMPONENT_NAME = 'social-blog-rich-content-editor-one-app';

export default withLazyImport(RICH_CONTENT_EDITOR_ONE_APP_COMPONENT_NAME)(() =>
  import(
    /* webpackChunkName: "rich-content-editor-one-app" */
    './rich-content-editor-one-app'
  ),
);
